module.exports = __webpack_public_path__ + "img/38-5.7441c6fd.jpg";